import { useContext } from 'react';
import CaptchaContext from '../contexts/captcha_context';

export default () => useContext(CaptchaContext);
